import cx from 'clsx';
import React from 'react';

import style from './style.module.scss';

const ProgressBar = ({ currentStep, steps }) => {
  const percent = Math.round(((currentStep - 1) / steps.length) * 100);

  return (
    <div className={style.progressBarBlock}>
      <span className={style.progressBarBlockPercent}>{percent}%</span>
      <div className={style.progressBlock}>
        {steps.map((step, i) => (
          <span
            key={i}
            className={cx(style.progressBlockItem, {
              [style.activeItem]: i < currentStep - 1,
            })}
          />
        ))}
      </div>
    </div>
  );
};

export default ProgressBar;
